// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"550":"af2408ac","741":"1b49dea3","1387":"b722a1b1","7633":"c6c3d530","8400":"87594367"}[chunkId] + ".chunk.css";
};